import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const DIM = { sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-8 w-8' } as const;

/** Accessible loading indicator. Keeps spinning under reduced-motion (essential). */
export function Spinner({ size = 'md', className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      data-motion="essential"
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-current border-t-transparent',
        DIM[size],
        className,
      )}
    />
  );
}
